export enum VerificationAdditionalCheckStatusEnum {
  WITHOUT_STATE = 'WITHOUT_STATE',
  WITH_STATE = 'WITH_STATE'
}
